export const PERMISSIONS = {
    Dashboard: {
        READ: 'Dashboard.READ',
    },
    Business: {
        CREATE: 'Business.CREATE',
        PATCH: 'Business.PATCH',
        PATCH_ME: 'Business.PATCH_ME',
        DELETE: 'Business.DELETE',
        DELETE_ME: 'Business.DELETE_ME',
        READ: 'Business.READ',
        RESTORE: 'Business.RESTORE',
    },
    User: {
        CREATE: 'User.CREATE',
        PATCH: 'User.PATCH',
        DELETE: 'User.DELETE',
        READ: 'User.READ',
        RESTORE: 'User.RESTORE',
    },
    Permission: {
        CREATE: 'Permission.CREATE',
        PATCH: 'Permission.PATCH',
        DELETE: 'Permission.DELETE',
        READ: 'Permission.READ',
        RESTORE: 'Permission.RESTORE',
    },
    Role: {
        CREATE: 'Role.CREATE',
        PATCH: 'Role.PATCH',
        DELETE: 'Role.DELETE',
        READ: 'Role.READ',
        RESTORE: 'Role.RESTORE',
    },
    ShopOrder: {
        EXPORT: 'ShopOrder.EXPORT',
    },
};
